module.exports = __webpack_public_path__ + "img/Warning.2fef69cf.png";